import styled, { css, keyframes } from 'styled-components'

interface CardProps {
  minWidth: number
  textLength?: number
}

const fade = keyframes`
  from {
    opacity: 0.7;
  }

  to {
    opacity: 1;
  }
`
export const Card = styled.div<{
  isLoading: boolean
}>`
  background: white; // pegar tema
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-radius: 0.8rem;
  padding: 2rem 0;
  ${props =>
    props.isLoading &&
    css`
      animation: 1.5s ${fade} alternate infinite;
    `}
`
export const Quantity = styled.div<CardProps>`
  min-width: ${({ minWidth }) => minWidth}rem;
  display: flex;
  justify-content: center;
  justify-content: space-around;
  align-items: center;
  border-radius: 0.8rem;
  color: white;
  font-size: ${({ textLength }) => (textLength > 10 ? '2.5rem' : '3.5rem')};
  font-weight: bold;
  position: relative;
  left: -1.1rem;
  width: 30.9rem;
  height: 13.5rem;
  &.property {
    background: ${({ theme }) => theme.colors.colorCardProperty};
    color: white;
  }
  &.netWeight {
    background: ${({ theme }) => theme.colors.colorCardNetWeight};
    color: white;
  }
  &.sifProd {
    background: ${({ theme }) => theme.colors.colorCardSif};
    color: white;
  }
  &.order {
    background: ${({ theme }) => theme.colors.colorCardOrder};
    color: white;
  }
  &.sifSlaughter {
    background: ${({ theme }) => theme.colors.colorCardSifSlaughter};
    color: white;
  }
  &.sku {
    background: ${({ theme }) => theme.colors.colorCardSku};
    color: white;
  }
`
export const Section = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`
export const Service = styled.div``
export const Title = styled.div`
  color: ${({ theme }) => theme.colors.primary2};
  font-size: 1.8rem;
  font-weight: bolder;
  padding-bottom: 0.5rem;
`
export const Description = styled.div`
  color: #000000;
  font-size: 1.2rem;
`
export const Icon = styled.div`
  height: 4.9rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1.2rem;
  padding: 0.5rem;
  &:hover {
    background: #00000006;
    border-radius: 50%;
  }
`
